// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-skeleton-container.opacity-0 .box{opacity:0}.k-skeleton-container.opacity-0 .kong-icon{display:none}.k-skeleton-container.opacity-0.mr-2{margin-right:0!important}", ""]);
// Exports
module.exports = exports;
